import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Pager({ page, pageSize, total, onPage, onPageSize }) {
  const ALL = 1000000;
  const isAll = pageSize >= ALL;
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 text-sm" data-testid="pagination">
      <div className="flex items-center gap-2 text-muted-foreground">
        Rows per page
        <Select value={isAll ? "all" : String(pageSize)} onValueChange={(v) => onPageSize(v === "all" ? ALL : Number(v))}>
          <SelectTrigger className="w-24 h-8" data-testid="page-size-select"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-card">
            {[10, 25, 50, 100].map((n) => <SelectItem key={n} value={String(n)} data-testid={`page-size-${n}`}>{n}</SelectItem>)}
            <SelectItem value="all" data-testid="page-size-all">Show all</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-3">
        <span className="font-mono text-xs text-muted-foreground" data-testid="pagination-info">{from}–{to} of {total} · page {page}/{pages}</span>
        <Button size="icon" variant="outline" className="h-8 w-8" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid="prev-page-button"><ChevronLeft size={14} /></Button>
        <Button size="icon" variant="outline" className="h-8 w-8" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid="next-page-button"><ChevronRight size={14} /></Button>
      </div>
    </div>
  );
}
